import { Ship } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
  subMessage?: string;
  showGenerationNote?: boolean;
}

const LoadingSpinner = ({ message = 'Loading...', subMessage, showGenerationNote }: LoadingSpinnerProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6">
      <div className="relative mb-8">
        <div className="w-20 h-20 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <Ship className="w-8 h-8 text-primary animate-pulse" />
        </div>
      </div>
      <h2 className="text-xl font-bold text-foreground mb-2 text-center">{message}</h2>
      {subMessage && (
        <p className="text-muted-foreground text-center">{subMessage}</p>
      )}
      {showGenerationNote && (
        <p className="text-xs text-muted-foreground/70 text-center mt-4 max-w-xs">
          Generating fresh content may take up to 50 seconds
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
